import { createContext } from 'react';

import { Context } from '../../../types';
import { Market } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

type MarketContextType = Context<Market>;

const marketContext = createContext<MarketContextType>(getContextDefaultValues(api));
export default marketContext;
